import React from 'react';
import PowerBIViewer from './PowerBIViewer';

const PowerBIDashboard = () => {
    return (
        <>
            <PowerBIViewer/>
        </>
    );
};

export default PowerBIDashboard;
